export const CNPJ_MASK_REGEX =
  /^[A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4}-\d{2}$/;

export function isValidCnpj(cnpj: string): boolean {
  const clean = (cnpj || '').toUpperCase().replace(/[.\-/]/g, '');

  if (!/^[A-Z0-9]{12}\d{2}$/.test(clean)) return false;
  if (/^(.)\1{13}$/.test(clean)) return false;

  const charValue = (ch: string): number => ch.charCodeAt(0) - 48;

  const calcDigit = (length: number): number => {
    let sum = 0;
    let weight = length - 7; // 12 => 5, 13 => 6
    for (let i = 0; i < length; i++) {
      sum += charValue(clean[i]) * weight;
      weight = weight - 1 < 2 ? 9 : weight - 1;
    }
    const rest = sum % 11;
    return rest < 2 ? 0 : 11 - rest;
  };

  if (calcDigit(12) !== parseInt(clean[12], 10)) return false;
  return calcDigit(13) === parseInt(clean[13], 10);
}

const VALID_DDDS = new Set([
  11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34, 35,
  37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 53, 54, 55, 61, 62, 63, 64,
  65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85, 86, 87, 88,
  89, 91, 92, 93, 94, 95, 96, 97, 98, 99,
]);

const SQL_KEYWORDS =
  /\b(?:select|insert|update|delete|drop|alter|truncate|union|exec|execute|create)\b/i;

export function hasUnsafeContent(value: string): boolean {
  if (!value) return false;
  return (
    /[<>]/.test(value) ||
    /javascript:/i.test(value) ||
    value.includes('--') ||
    value.includes(';') ||
    SQL_KEYWORDS.test(value)
  );
}

export function hasInjectionPattern(value: string): boolean {
  if (!value) return false;
  const patterns = [
    /union\s+select/i,
    /select[\s\S]+?from/i,
    /insert\s+into/i,
    /delete\s+from/i,
    /update[\s\S]+?set/i,
    /drop\s+table/i,
    /'\s*or\b/i,
    /\bor\s+1\s*=\s*1\b/i,
    /;\s*drop/i,
    /<[^>]*>/,
    /javascript:/i,
  ];
  return patterns.some((re) => re.test(value));
}

export function isValidBrazilianPhone(phone: string): boolean {
  const digits = phone.replace(/\D/g, '');

  if (digits.length !== 11) return false;
  if (/^(\d)\1+$/.test(digits)) return false;

  const ddd = parseInt(digits.substring(0, 2), 10);
  if (!VALID_DDDS.has(ddd)) return false;

  if (digits.charAt(2) !== '9') return false;

  return true;
}
